import { API } from '../../../service/common/api';
import { BASE_URL, CONTRACT_URL } from '../../../service/common/env';

export const getPracticesOnContract: any = (producerData: any, country: string) => (dispatch: any) => {
  const isBrUser = country === 'br';
  const pricebookId = producerData?.Pricebook2Id;
  const opportunityId = producerData?.opportunityId;
  return API.post(`${CONTRACT_URL}/contract-service/contract/contract-versions/active-version?country=${isBrUser ? 'BR' : 'US'}`, {
    optionAOnly: false,
  })
    .then((res) => {
      const templateId = res.data.docusign_id;
      return API.get(`${BASE_URL}/base/producer/contract-practices`, {
        opportunityId,
        pricebookId,
        templateId,
      });
    })
    .then((response: any) => {
      dispatch({
        type: 'GET_PRACTICES_ON_CONTRACT_SUCCEEDED',
        payload: response?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: 'GET_PRACTICES_ON_CONTRACT_ERRORED',
        payload: err,
      });
      // TODO add a proper error handling
      console.log(`Couldn't get practices: getPracticesOnContract error - ${JSON.stringify(err)}`);
      throw err;
    });
};
